module.exports = "/_next/static/images/3daf844e513951ae58316e49696ef8c1-payment_delay.png";